// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ce8eae6","455":"0cc966f5","977":"2dc64885"}[chunkId] + ".chunk.js";
};